import Button from "@mui/material/Button";

export default function SGTransparentBGBtn(props) {
    const btnProps = {
        className: 'transparent-back-btn',
        ...props,
    };
    return <Button {...btnProps} />;

}